import { Building2, FileCheck2, Settings2, UserCheck } from "lucide-react";
import { cn } from "@/lib/utils";
import type { Sncr } from "./api";
import { formatNumero } from "./cidades";
import { Kpi, type Variante } from "./KpiCards";

interface SncrCardsProps {
  data?: Sncr;
  isLoading: boolean;
  variante?: Variante;
}

/** Adoção do SNCR (numeração de receituário da Anvisa). Sempre o total, não segue o período. */
export function SncrCards({ data, isLoading, variante = "padrao" }: SncrCardsProps) {
  const tv = variante === "tv";
  return (
    <div className={cn("grid gap-4", tv ? "h-full grid-cols-2 gap-8" : "sm:grid-cols-2 lg:grid-cols-4")}>
      <Kpi
        icone={FileCheck2}
        titulo="Receitas com numeração SNCR"
        valor={data?.receitasComSncr}
        detalhe={data && `+${formatNumero(data.receitasComSncrMesAtual)} neste mês`}
        isLoading={isLoading}
        tv={tv}
      />
      <Kpi
        icone={UserCheck}
        titulo="Profissionais usando o SNCR"
        valor={data?.profissionaisComLote}
        detalhe="Com algum lote de numeração"
        isLoading={isLoading}
        tv={tv}
      />
      <Kpi
        icone={Building2}
        titulo="Instituições usando o SNCR"
        valor={data?.instituicoesComLote}
        detalhe="Com algum profissional com lote"
        isLoading={isLoading}
        tv={tv}
      />
      <Kpi
        icone={Settings2}
        titulo="Instituições com SNCR liberado"
        valor={data?.instituicoesSncrLiberado}
        detalhe="Ativo nas configurações"
        isLoading={isLoading}
        tv={tv}
      />
    </div>
  );
}
